// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8f80d12","732":"4ef198aa","977":"c28db058"}[chunkId] + ".chunk.js";
};